import _ from 'lodash';
import {
  IotOBDYSplitter
} from '../../../utils/constant';

export const getUpdatedAccessoriesList = (accessoriesList) => {
  const updatedAccessoriesList = _.cloneDeep(accessoriesList);

  updatedAccessoriesList.forEach(el => {
    if (el.fields && el.fields.hardwareName && el.fields.hardwareName === IotOBDYSplitter) {
      el.sys.id = '4kWRXy1N3hmZ7CnB5Jf0Ranew'
      el.fields.unitPrice = 50;
    }
  })
  return updatedAccessoriesList;
}
